export const theFunction = () => {
  /**
   * Private ecommerce tracking function
   */
  window._trackEcommerce = function (event, data) {
    if (typeof window.dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({"event": event, ecommerce: data});
  };

  /**
   * Add to cart
   */
  window.trackAddToCart = function (line) {
    var gtagItems = [];

    var sum = 0;

    (line.lines || []).forEach((product) => {
      console.log('Adding item ' + product.id);

      gtagItems.push({
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        item_category2: product.category2 || '',
        price: product.price,
        quantity: product.quantity,
      });

      sum = sum + (product.price * product.quantity);
    });

    window._trackEcommerce('add_to_cart', {
      value: sum,
      currency: "SEK",
      items: gtagItems,
    });
  };

  /**
   * View item
   */
  window.trackViewItem = function (line) {
    var gtagItems = [];

    var sum = 0;

    (line.lines || []).forEach((product) => {
      console.log('Viewing item ' + product.id);

      gtagItems.push({
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        item_category2: product.category2 || '',
        price: product.price,
        quantity: product.quantity,
      });

      sum = sum + (product.price * product.quantity);
    });

    window._trackEcommerce('view_item', {
      value: sum,
      currency: "SEK",
      items: gtagItems,
    });
  };

  /**
   * View cart
   */
  window.trackViewCart = function (lines, currency, sum) {
    var gtagItems = [];

    (lines || []).forEach((item) => {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity,
      });
    });

    window._trackEcommerce('view_cart', {
      value: sum,
      currency: currency,
      items: gtagItems,
    });
  };

  /**
   * Begin checkout
   */
  window.BEGIN_CHECKOUT_TRACKED = false;

  window.trackBeginCheckout = function (data, orderId, sum) {
    if (window.BEGIN_CHECKOUT_TRACKED) {
      console.log('skipping tracking due to already tracked');
      return;
    }

    window.BEGIN_CHECKOUT_TRACKED = true;

    var gtagItems = [];

    (data || []).forEach((item) => {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity,
      });
    });

    window._trackEcommerce('begin_checkout', {
      transaction_id: orderId,
      value: sum,
      currency: "SEK",
      items: gtagItems,
    });
  };

  /**
   * Purchase
   */
  window.trackPurchase = function (data, orderId, sum, customer) {
    var gtagItems = [];

    (data || []).forEach((item) => {
      console.log('Adding item ' + item.sku);

      gtagItems.push({
        item_id: item.sku,
        item_name: item.name,
        item_category: item.type,
        item_category2: item.category2 || '',
        price: item.price,
        quantity: item.quantity,
      });
    });

    window._trackEcommerce('purchase', {
      transaction_id: orderId,
      value: sum,
      currency: "SEK",
      items: gtagItems,
      sha256_email_address: customer.email || '',
      sha256_phone_number: customer.mobilePhoneNumber || '',
      address: {
        sha256_first_name: (customer.billingAddress && customer.billingAddress.firstName) ? customer.billingAddress.firstName : '',
        sha256_last_name: (customer.billingAddress && customer.billingAddress.lastName) ? customer.billingAddress.lastName : '',
        street: (customer.billingAddress && customer.billingAddress.address) ? customer.billingAddress.address : '',
        city: (customer.billingAddress && customer.billingAddress.city) ? customer.billingAddress.city : '',
        postal_code: (customer.billingAddress && customer.billingAddress.postalCode) ? customer.billingAddress.postalCode : '',
        country: (customer.billingAddress && customer.billingAddress.country) ? customer.billingAddress.country : '',
      },
    });
  };
};

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/stats.js